/**
 * Shared keyboard helpers for global shortcut handling.
 */

/**
 * True when the event target is a field the user is typing into, so single-key
 * shortcuts (e.g. `f`, `t`, `g`, `?`) should be ignored. Modifier combos like
 * Cmd/Ctrl+K deliberately bypass this and remain active inside inputs.
 */
export function isTypingTarget(target: EventTarget | null): boolean {
  if (!(target instanceof HTMLElement)) return false
  const tag = target.tagName
  return tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT' || target.isContentEditable
}

/** Platform-specific label for the Cmd/Ctrl+K search shortcut. */
export function getSearchShortcutLabel(): string {
  if (typeof navigator === 'undefined') return 'Ctrl K'

  const nav = navigator as Navigator & {
    userAgentData?: {
      platform?: string
    }
  }
  const platform =
    nav.userAgentData?.platform ?? navigator.platform ?? navigator.userAgent ?? ''

  return /Mac|iPhone|iPod|iPad/i.test(platform) ? '⌘K' : 'Ctrl K'
}
